import React from "react";
import { Users } from "lucide-react";

import BasePage from "../basePage";

import { CrmPetFilter } from "./CrmPetFilter";
import { CrmPetRuleTabs } from "./CrmPetRuleTabs";
import { CrmPetSummary } from "./CrmPetSummary";
import { CrmPetTable } from "./CrmPetTable";
import { ConfigModal } from "./Modals/ConfigModal";
import { ContactHistoryModal } from "./Modals/ContactHistoryModal";
import { Container } from "./styles";

export function CrmPet() {
  return (
    <BasePage pageTitle={<span style={{ display: "flex", alignItems: "center", gap: 8 }}><Users className='w-6 h-6' />CRM Pet</span>}>
      <Container>
        <CrmPetRuleTabs />
        <CrmPetFilter />
        <CrmPetSummary />
        <CrmPetTable />
      </Container>
      <ConfigModal />
      <ContactHistoryModal />
    </BasePage>
  );
}

export default CrmPet;
